import { FC } from 'react';
import { REDIRECT_URL } from 'services/constants/env';

const host = document.location.hostname;
const hostKeycloak =
	host === 'dashboard.easproject.com' ? 'id.easproject.com' : 'id-dev.easproject.com';

export const LoginPage: FC = () => {
	const ID_URL = `https://${hostKeycloak}/auth/realms/dashboard/protocol/openid-connect/auth?response_type=code&client_id=dashboard-ui&redirect_uri=${
		REDIRECT_URL ?? 'http://localhost:3000'
	}`;

	window.location.assign(ID_URL);

	return <div />;
};
